module.exports = __webpack_public_path__ + "img/chargeQuestion.23e3d884.svg";